import { render, staticRenderFns } from "./picture-upload-fileTypes-editor.vue?vue&type=template&id=651805a2&scoped=true&"
import script from "./picture-upload-fileTypes-editor.vue?vue&type=script&lang=js&"
export * from "./picture-upload-fileTypes-editor.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651805a2",
  null
  
)

export default component.exports